type CriterionRef = { id: string };

/**
 * De criteria die daadwerkelijk gevalideerd worden: de geladen lijst van het
 * perspectief min de door de gebruiker uitgezette criteria.
 */
export const selectActiveCriterionIds = (
  criteria: ReadonlyArray<CriterionRef>,
  inactiveCriterionIds: ReadonlySet<string>,
): string[] => criteria.filter((c) => !inactiveCriterionIds.has(c.id)).map((c) => c.id);

export const countActiveCriteria = (
  criteria: ReadonlyArray<CriterionRef>,
  inactiveCriterionIds: ReadonlySet<string>,
): number => criteria.reduce((n, c) => (inactiveCriterionIds.has(c.id) ? n : n + 1), 0);
